var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36,0.9C16.6,0.9,0.9,16.6,0.9,36S16.6,71.1,36,71.1S71.1,55.4,71.1,36S55.4,0.9,36,0.9z M22.3,22.5l12.4-3 c0.8-0.2,1.7-0.2,2.6,0l12.4,3c1.2,0.3,1.2,1.8,0,2l-5.3,1.3l-0.1,3.9c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3l0-3.9L24.3,25v3.4 c0.5,0.3,0.8,0.7,0.8,1.3c0,0.5-0.3,1-0.7,1.3l1,4.1c0.1,0.4-0.1,0.9-0.5,0.9h-2.7c-0.4,0-0.6-0.5-0.5-0.9l1-4 c-0.4-0.3-0.7-0.7-0.7-1.3c0-0.6,0.3-1,0.8-1.3v-3.8l-0.4-0.1C21.1,24.3,21.1,22.8,22.3,22.5z M48.3,52.6H23.7c-1.2,0-2.3-1-2.3-2.3 c0-5,3.3-9.2,7.9-10.7l6.7,6.7l6.7-6.7c4.5,1.4,7.9,5.7,7.9,10.7C50.6,51.6,49.6,52.6,48.3,52.6z"
});

function SvgIconModeratorUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000139272031033397369170000016578193759797485444_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModeratorUser);
export default __webpack_public_path__ + "static/media/icon_moderatorUser.c429925e.svg";
export { ForwardRef as ReactComponent };